import { useEffect, useState } from 'react';
import { usePendingGenerations, PendingGen } from '@/context/pending-generations.context';
import { GenerationReadyModal } from './GenerationReadyModal';

export function GlobalGenerationManager() {
  const { generations, markSeen } = usePendingGenerations();
  const [activeGen, setActiveGen] = useState<PendingGen | null>(null);

  useEffect(() => {
    const nextReady = generations.find(g => g.status === 'ready' && g.id !== activeGen?.id);
    if (nextReady && !activeGen) {
      setActiveGen(nextReady);
    }
  }, [generations, activeGen]);

  const handleCloseModal = () => {
    if (activeGen) {
      markSeen(activeGen.id);
      setActiveGen(null);
    }
  };

  return <GenerationReadyModal gen={activeGen} onClose={handleCloseModal} />;
}
